// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-validation-container {
  font-family: Roboto;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px;
  margin: 0 auto;
  gap: 32px !important;
}

.case-validation-container h1,
.case-validation-container h2,
.case-validation-container h3,
.case-validation-container h4,
.case-validation-container h5,
.case-validation-container h6,
.case-validation-container p,
.case-validation-container ul,
.case-validation-container ol {
  margin: 0 !important;
}

.case-validation-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.validation-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-icon {
  color: #1976d2;
  font-size: 20px;
}

.first-time-offender-button {
  padding: 3px 4px;
  font-size: 12px;
  color: #1976d2;
  background-color: transparent;
  border: 1px solid #1976d2;
  border-radius: 16px;
  cursor: pointer;
}

.validation-item-view {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  gap: 16px;
}

.validation-item-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.validation-icon-error {
  color: #d32f2f;
  font-size: 20px;
}

.validation-icon-success {
  color: #2e7d32;
  font-size: 20px;
}

.validation-item-text {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.override-details-wrapper {
  overflow: hidden;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  width: 96%;
  margin-bottom: 16px;
  margin-left: 35px;
}

.override-details-table {
  width: 100%;
  border-collapse: collapse;
}

.override-details-table th {
  padding: 12px 16px;
  text-align: left;
  font-size: 12px;
}

.override-details-table td {
  padding: 0px 16px;
  text-align: left;
  font-size: 12px;
}

.override-details-table th {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
  background-color: #f2f5fa;
}

.override-detail-value {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.view-evidence-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.override-button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  color: #1976d2;
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.override-button button {
  font-family: Roboto;
  font-weight: 500;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0.46px;
  text-transform: uppercase;
}

.expand-icon {
  font-size: 18px;
  transition: transform 0.3s;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

.expand-icon-secondary {
  font-size: 18px;
  color: #666;
  transition: transform 0.3s;
}

.expand-icon-secondary.expanded {
  transform: rotate(180deg);
}

.question-box-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}
.question-box {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
.evidence-action-wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: 16px;
}

.title-header {
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 160%;
  letter-spacing: 0.15px;
}
.title-sub-header {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
}
.contravention-box {
  border-radius: 4px;
  margin-bottom: 15px;
  flex: 2;
}
.evidence-box {
  border-radius: 4px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1.5;
}
.evidence-header {
  padding-left: 5px;
  margin-top: 5px;
  display: flex;
}
.contravention-header {
  display: flex;
  margin-bottom: 10px;
  gap: 20px;
}

.contravention-label {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.contravention-text {
  margin: 8px 0 0 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
}

.evidence-label {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.view-evidence-link {
  color: #1976d2;
  font-family: Roboto;
  font-weight: 500;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 22px;
  letter-spacing: 0.46px;
  text-transform: uppercase;
}

.permit-details-box {
  border: 1px solid #ffe082;
  border-radius: 6px;
  overflow: hidden;
  margin-top: 16px;
}

.warning-alert-box {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  background-color: #fff3e0;
  padding: 12px;
}

.warning-icon {
  color: #f57c00;
  width: 22px;
  height: 19px;
  opacity: 1;
  top: 18px;
  left: 21px;
}
.warning-header {
  display: flex;
  column-gap: 7px;
}
.warning-text {
  margin: 0;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #cc630c;
}

.permit-details-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  padding: 15px;
}

.permit-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.permit-detail-label {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
}

.permit-detail-value {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.ceo-notes-section {
  margin-top: 16px;
}

.ceo-notes-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.notes-icon {
  color: #1976d2;
  width: 18;
  height: 16;
  opacity: 1;
  top: 8px;
  left: 4px;
}

.case-list {
  margin-top: 8px;
  margin-bottom: 32px;
  padding: 0 !important;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #757575;
}
.vrm-container {
  display: flex;
  /* gap: 8px; */
}

.vrm-title-box {
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  /* align-items: center; */
  width: 100%;
}
.vrm-content {
  display: flex;
  align-items: center;
  justify-content: start;
  height: 100% !important;
}
.vrm-title {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  background-color: #f2f5fa;
  padding: 10px 16px;
  text-align: left;
}

.vrm-content-box {
  display: flex;
  /* align-items: center; */
  justify-content: start;
}
.vrm-content {
  margin: 0;
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 150%;
  letter-spacing: 0.15px;
  padding: 10px 8px;
  text-align: left;
}
.selector {
  padding: 0;
}
.switcher {
  padding: 10px 16px;
}
.title-head {
  flex: 3 !important;
}
.title-button {
  flex: 3 !important  ;
}
.title-selector {
  flex: 3 !important;
}
.title-switcher {
  flex: 2 !important;
}
.contravention-grp-btn {
  display: flex;
}
.contravention-left
  .StageTwoButtonComponentMainSection
  .dPSButtonComponentSection.MuiButton-outlined.MuiButton-outlinedPrimary,
.contravention-left
  .StageTwoButtonComponentMainSection
  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {
  border-bottom-right-radius: unset !important;
  border-top-right-radius: unset !important;
  height: 35px !important;
  width: 100px !important;
  box-shadow: none !important;
}

.contravention-right
  .StageTwoButtonComponentMainSection
  .dPSButtonComponentSection.MuiButton-outlined.MuiButton-outlinedPrimary,
.contravention-right
  .StageTwoButtonComponentMainSection
  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {
  border-bottom-left-radius: unset !important;
  border-top-left-radius: unset !important;
  height: 35px !important;
  width: 100px !important;
  box-shadow: none !important;
}

.disable-contravention-btn.MuiButton-outlined {
  pointer-events: none;
  background-color: transparent !important;
  border-color: #bdbdbd !important;
  color: #9e9e9e !important;
}
.disable-contravention-btn.MuiButton-contained {
  pointer-events: none;
  background-color: #e0e0e0 !important;
  border-color: #bdbdbd !important;
  color: #757575 !important;
}
.match-container {
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.validation-item {
  display: flex;
  justify-content: space-between;
}
.override-reason-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 143%;
  letter-spacing: 0.17px;
  text-align: center;
  vertical-align: middle;
  color: #757575;
}
.contravention-details-ceo {
  display: flex;
  align-items: center;
  justify-content: start;
  column-gap: 4px;
  color: #757575;
}
.supported-doc-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.supported-documents {
  flex: 1;
  padding: 24px 24px;
}
.supported-doc-list {
  display: flex;
  flex-direction: column;
  margin: 24px 0px;
}
.supported-doc-list p {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 143%;
  letter-spacing: 0.17px;
}
.doc-item {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}
.doc-item
  svg.MuiSvgIcon-root.MuiSvgIcon-colorDisabled.MuiSvgIcon-fontSizeMedium {
  cursor: pointer;
}
.corres-section {
  margin-top: 16px;
}
.corres-section h3 {
  font-family: Roboto;
  font-weight: 500;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 160%;
  letter-spacing: 0.15px;
}
.correspondences-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  font-family: Roboto;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
.corres-detail-box {
  display: flex;
  gap: 4px;
}
.corres-container {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 12px 0px;
}
.challenge-detail-container {
  padding: 12px 16px 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.challenge-detail-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 200px;
  max-height: 500px;
  overflow: auto;
  scrollbar-width: 2px !important;
  margin-top: 16px;
}
.challenge-left-sec {
  display: flex;
  align-items: center;
  column-gap: 12px;
}
.challenge-right-sec {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.challenge-right-sec,
.challenge-left-sec p {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 143%;
  letter-spacing: 0.17px;
  text-align: center;
  vertical-align: middle;
  color: #757575;
}
.challenge-right-sec img {
  cursor: pointer;
}
.challenge-sub-section {
  display: flex;
  min-height: 200px;
  scrollbar-width: 2px !important;
}
.challenge-summary-box {
  display: flex;
  flex-direction: column;
  background-color: #f2f5fa;
  flex: 1;
  padding: 16px;
  gap: 12px;
  scrollbar-width: 2px !important;
}
.summary-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0px;
}
.summary-list {
  padding: 0px 40px;
}
.summary-list li {
  padding: 4px 0px;
}
.summary-title {
  display: flex;
  align-items: center;
  column-gap: 4px;
}
.permit-details-box .buttonContainer .MuiButton-text.MuiButton-textInherit {
  color: #663c00;
  column-gap: 8px;
}
.validation-item .buttonContainer .MuiButton-text.MuiButton-textPrimary {
  column-gap: 18px;
}
.contravention-grp-btn
  .StageTwoButtonComponentMainSection
  .dPSButtonComponentSection {
  column-gap: 7px;
}
.hide-override {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/views/components/custom/Case Validation/CaseValidation.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;;;;;EASE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;;;;;;EAME,4CAA4C;EAC5C,yCAAyC;EACzC,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;;;;;EAME,2CAA2C;EAC3C,wCAAwC;EACxC,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,OAAO;EACP,aAAa;EACb,SAAS;EACT,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,aAAa;AACf","sourcesContent":[".case-validation-container {\n  font-family: Roboto;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 10px;\n  margin: 0 auto;\n  gap: 32px !important;\n}\n\n.case-validation-container h1,\n.case-validation-container h2,\n.case-validation-container h3,\n.case-validation-container h4,\n.case-validation-container h5,\n.case-validation-container h6,\n.case-validation-container p,\n.case-validation-container ul,\n.case-validation-container ol {\n  margin: 0 !important;\n}\n\n.case-validation-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.validation-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.header-icon {\n  color: #1976d2;\n  font-size: 20px;\n}\n\n.first-time-offender-button {\n  padding: 3px 4px;\n  font-size: 12px;\n  color: #1976d2;\n  background-color: transparent;\n  border: 1px solid #1976d2;\n  border-radius: 16px;\n  cursor: pointer;\n}\n\n.validation-item-view {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  gap: 16px;\n}\n\n.validation-item-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.validation-icon-error {\n  color: #d32f2f;\n  font-size: 20px;\n}\n\n.validation-icon-success {\n  color: #2e7d32;\n  font-size: 20px;\n}\n\n.validation-item-text {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.override-details-wrapper {\n  overflow: hidden;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n  width: 96%;\n  margin-bottom: 16px;\n  margin-left: 35px;\n}\n\n.override-details-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.override-details-table th {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 12px;\n}\n\n.override-details-table td {\n  padding: 0px 16px;\n  text-align: left;\n  font-size: 12px;\n}\n\n.override-details-table th {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n  background-color: #f2f5fa;\n}\n\n.override-detail-value {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.view-evidence-link {\n  color: #1976d2;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.override-button {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0;\n  color: #1976d2;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.override-button button {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 13px;\n  leading-trim: NONE;\n  line-height: 22px;\n  letter-spacing: 0.46px;\n  text-transform: uppercase;\n}\n\n.expand-icon {\n  font-size: 18px;\n  transition: transform 0.3s;\n}\n\n.expand-icon.expanded {\n  transform: rotate(180deg);\n}\n\n.expand-icon-secondary {\n  font-size: 18px;\n  color: #666;\n  transition: transform 0.3s;\n}\n\n.expand-icon-secondary.expanded {\n  transform: rotate(180deg);\n}\n\n.question-box-container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 15px;\n}\n.question-box {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n.evidence-action-wrapper {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  column-gap: 16px;\n}\n\n.title-header {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 20px;\n  leading-trim: NONE;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n}\n.title-sub-header {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n}\n.contravention-box {\n  border-radius: 4px;\n  margin-bottom: 15px;\n  flex: 2;\n}\n.evidence-box {\n  border-radius: 4px;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1.5;\n}\n.evidence-header {\n  padding-left: 5px;\n  margin-top: 5px;\n  display: flex;\n}\n.contravention-header {\n  display: flex;\n  margin-bottom: 10px;\n  gap: 20px;\n}\n\n.contravention-label {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.contravention-text {\n  margin: 8px 0 0 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n}\n\n.evidence-label {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.view-evidence-link {\n  color: #1976d2;\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 13px;\n  leading-trim: NONE;\n  line-height: 22px;\n  letter-spacing: 0.46px;\n  text-transform: uppercase;\n}\n\n.permit-details-box {\n  border: 1px solid #ffe082;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-top: 16px;\n}\n\n.warning-alert-box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  background-color: #fff3e0;\n  padding: 12px;\n}\n\n.warning-icon {\n  color: #f57c00;\n  width: 22px;\n  height: 19px;\n  opacity: 1;\n  top: 18px;\n  left: 21px;\n}\n.warning-header {\n  display: flex;\n  column-gap: 7px;\n}\n.warning-text {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #cc630c;\n}\n\n.permit-details-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n  padding: 15px;\n}\n\n.permit-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.permit-detail-label {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n}\n\n.permit-detail-value {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.ceo-notes-section {\n  margin-top: 16px;\n}\n\n.ceo-notes-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.notes-icon {\n  color: #1976d2;\n  width: 18;\n  height: 16;\n  opacity: 1;\n  top: 8px;\n  left: 4px;\n}\n\n.case-list {\n  margin-top: 8px;\n  margin-bottom: 32px;\n  padding: 0 !important;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #757575;\n}\n.vrm-container {\n  display: flex;\n  /* gap: 8px; */\n}\n\n.vrm-title-box {\n  display: flex;\n  flex-direction: column;\n  /* justify-content: space-between; */\n  /* align-items: center; */\n  width: 100%;\n}\n.vrm-content {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  height: 100% !important;\n}\n.vrm-title {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  background-color: #f2f5fa;\n  padding: 10px 16px;\n  text-align: left;\n}\n\n.vrm-content-box {\n  display: flex;\n  /* align-items: center; */\n  justify-content: start;\n}\n.vrm-content {\n  margin: 0;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  leading-trim: NONE;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  padding: 10px 8px;\n  text-align: left;\n}\n.selector {\n  padding: 0;\n}\n.switcher {\n  padding: 10px 16px;\n}\n.title-head {\n  flex: 3 !important;\n}\n.title-button {\n  flex: 3 !important  ;\n}\n.title-selector {\n  flex: 3 !important;\n}\n.title-switcher {\n  flex: 2 !important;\n}\n.contravention-grp-btn {\n  display: flex;\n}\n.contravention-left\n  .StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection.MuiButton-outlined.MuiButton-outlinedPrimary,\n.contravention-left\n  .StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {\n  border-bottom-right-radius: unset !important;\n  border-top-right-radius: unset !important;\n  height: 35px !important;\n  width: 100px !important;\n  box-shadow: none !important;\n}\n\n.contravention-right\n  .StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection.MuiButton-outlined.MuiButton-outlinedPrimary,\n.contravention-right\n  .StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection.MuiButton-contained.MuiButton-containedPrimary {\n  border-bottom-left-radius: unset !important;\n  border-top-left-radius: unset !important;\n  height: 35px !important;\n  width: 100px !important;\n  box-shadow: none !important;\n}\n\n.disable-contravention-btn.MuiButton-outlined {\n  pointer-events: none;\n  background-color: transparent !important;\n  border-color: #bdbdbd !important;\n  color: #9e9e9e !important;\n}\n.disable-contravention-btn.MuiButton-contained {\n  pointer-events: none;\n  background-color: #e0e0e0 !important;\n  border-color: #bdbdbd !important;\n  color: #757575 !important;\n}\n.match-container {\n  padding: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.validation-item {\n  display: flex;\n  justify-content: space-between;\n}\n.override-reason-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 143%;\n  letter-spacing: 0.17px;\n  text-align: center;\n  vertical-align: middle;\n  color: #757575;\n}\n.contravention-details-ceo {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  column-gap: 4px;\n  color: #757575;\n}\n.supported-doc-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.supported-documents {\n  flex: 1;\n  padding: 24px 24px;\n}\n.supported-doc-list {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0px;\n}\n.supported-doc-list p {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 143%;\n  letter-spacing: 0.17px;\n}\n.doc-item {\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n}\n.doc-item\n  svg.MuiSvgIcon-root.MuiSvgIcon-colorDisabled.MuiSvgIcon-fontSizeMedium {\n  cursor: pointer;\n}\n.corres-section {\n  margin-top: 16px;\n}\n.corres-section h3 {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 20px;\n  leading-trim: NONE;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n}\n.correspondences-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  font-family: Roboto;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n.corres-detail-box {\n  display: flex;\n  gap: 4px;\n}\n.corres-container {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n  padding: 12px 0px;\n}\n.challenge-detail-container {\n  padding: 12px 16px 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.challenge-detail-section {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  min-height: 200px;\n  max-height: 500px;\n  overflow: auto;\n  scrollbar-width: 2px !important;\n  margin-top: 16px;\n}\n.challenge-left-sec {\n  display: flex;\n  align-items: center;\n  column-gap: 12px;\n}\n.challenge-right-sec {\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n}\n.challenge-right-sec,\n.challenge-left-sec p {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 14px;\n  leading-trim: NONE;\n  line-height: 143%;\n  letter-spacing: 0.17px;\n  text-align: center;\n  vertical-align: middle;\n  color: #757575;\n}\n.challenge-right-sec img {\n  cursor: pointer;\n}\n.challenge-sub-section {\n  display: flex;\n  min-height: 200px;\n  scrollbar-width: 2px !important;\n}\n.challenge-summary-box {\n  display: flex;\n  flex-direction: column;\n  background-color: #f2f5fa;\n  flex: 1;\n  padding: 16px;\n  gap: 12px;\n  scrollbar-width: 2px !important;\n}\n.summary-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 0px;\n}\n.summary-list {\n  padding: 0px 40px;\n}\n.summary-list li {\n  padding: 4px 0px;\n}\n.summary-title {\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n}\n.permit-details-box .buttonContainer .MuiButton-text.MuiButton-textInherit {\n  color: #663c00;\n  column-gap: 8px;\n}\n.validation-item .buttonContainer .MuiButton-text.MuiButton-textPrimary {\n  column-gap: 18px;\n}\n.contravention-grp-btn\n  .StageTwoButtonComponentMainSection\n  .dPSButtonComponentSection {\n  column-gap: 7px;\n}\n.hide-override {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
